import React from 'react';
import { Popover, Skeleton } from 'antd';
import { CheckOutlined, InfoCircleOutlined } from '@ant-design/icons';

import {
  USER_ACTION,
} from 'utils/constants';
import CommentsPopover from 'organisms/CommentsPopover';
import Table from 'atoms/Table';
import UserProfile from 'molecules/UserProfile';
import UsersActions from 'atoms/UsersActions';
import GroupTag from 'atoms/GroupTag';
import DateTime from 'atoms/DateTime';
import Hours from 'atoms/Hours';
import Loader from 'atoms/Loader';
import InfiniteScroll from 'react-infinite-scroller';
import ContentWrapper from 'atoms/ContentWrapper';
import { InfiniteScrollTableWrapper } from 'design/Styled';
import { LoaderDiv } from '../DailyGoals/AntStyled';
import {
  Content,
  Comments,
  Title,
} from './AntStyled';

export default function (props) {
  const {
    blockers, loading, onActions, archive, showReason, setSortData, hasMore, loader, handleInfiniteOnLoad, loginUser, handleGroupOrUserFilterChange, dataCount,
  } = props;

  const columns = [
    {
      dataIndex: 'spanone',
      key: 'spanone',
      className: 'no-padding mw-20',
    },
    {
      dataIndex: 'isCompleted',
      key: 'isCompleted',
      className: 'check-mark no-padding',
      align: 'center',
      render: isCompleted => isCompleted && <CheckOutlined />,
      // sorter: (a, b) => a.isCompleted - b.isCompleted,
    },
    {
      title: 'Title',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
      // ellipsis: true,
      render: (text, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : <Title>{text}</Title>,
      sorter: (a, b) => a.name.localeCompare(b.name),
      // sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Estimate',
      dataIndex: 'estimation',
      key: 'estimation',
      width: '9%',
      render: (estimation, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : estimation ? <Hours estTime={estimation} /> : '-',
      // sorter: (a, b) => a.estimation - b.estimation,
    },
    {
      title: 'Spent',
      dataIndex: 'completionHours',
      width: '7%',
      editable: false,
      render: (spent, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : spent ? <Hours estTime={spent || ''} /> : '-',
    },
    {
      title: 'Blocking',
      dataIndex: 'ownerUser',
      key: 'ownerUser',
      width: '10%',
      render: (ownerUser, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : ownerUser ? (
        <UserProfile
          profile={ownerUser.profileImage}
          name={ownerUser.firstName && ownerUser.lastName ? `${ownerUser.firstName} ${ownerUser.lastName}` : ownerUser.email}
          userId={ownerUser.id}
          showLink
        />
      ) : '-',
      // sorter: (a, b) => a.ownerUser - b.ownerUser,
    },
    {
      title: 'Assign To',
      dataIndex: 'user',
      key: 'user',
      width: '10%',
      render: (user, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : user ? (
        <UserProfile
          profile={user.profileImage}
          name={user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.email}
          userId={user.id}
          showLink
        />
      ) : '-',
      // sorter: (a, b) => a.user && a.user.length - b.user.length,
    },
    {
      title: 'Group',
      dataIndex: 'group',
      key: 'group',
      width: '8%',
      render: (group, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : <GroupTag {...group} />,
      // sorter: (a, b) => a.group.name.length - b.group.name.length,
    },
    {
      title: 'Created on',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : <DateTime date={date} />,
      sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),
    },
    {
      title: 'Completed on',
      dataIndex: 'completedOn',
      key: 'completedOn',
      render: (date, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : <DateTime date={date} />,
      // sorter: (a, b) => a.completedOn - b.completedOn,
    },
    {
      dataIndex: 'reason',
      key: 'reason',
      width: showReason ? '4.5%' : '0%',
      className: !showReason ? 'no-padding' : '',
      render: (row, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : rowData.isArchive && (
        <Popover content={rowData.reason} title="Reason">
          <InfoCircleOutlined className="infoicon" />
        </Popover>
      ),
    },
    {
      dataIndex: 'comment',
      key: 'comment',
      width: '5.5%',
      render: (row, rowData) => rowData.loading ? <Skeleton paragraph={{ rows: 1 }} title={false} active /> : <Comments><CommentsPopover actionId={rowData.id} data={rowData.comments} /></Comments>,
    },
    {
      align: 'center',
      dataIndex: 'action',
      width: '4%',
      key: 'action',
      render: (row, rowData) => (
        rowData.canArchive
        && (
          <UsersActions
            rowData={rowData}
            actions={archive ? [USER_ACTION.ARCHIVE_BLOCKER] : [USER_ACTION.RESTORE_BLOCKER]}
            onClickEvent={onActions}
          />
        )
      ),
    },
    {
      dataIndex: 'spantwo',
      key: 'spantwo',
      className: 'no-padding mw-20',
    },
  ];

  function onChange(pagination, filters, sorter) {
    if (sorter && sorter.field && sorter.order) {
      if (dataCount > blockers.length) {
        handleGroupOrUserFilterChange();
        if (sorter.order === 'ascend') {
          setSortData({ field: sorter.field, type: 'ASC' });
        } else {
          setSortData({ field: sorter.field, type: 'DESC' });
        }
      }
    }
  }

  return (
    <ContentWrapper>
      <Content>
        <InfiniteScrollTableWrapper>
          <InfiniteScroll
            initialLoad={false}
            pageStart={0}
            loadMore={handleInfiniteOnLoad}
            hasMore={!loader && hasMore}
            useWindow={false}
            threshold={20}
            loader={blockers.length && <LoaderDiv><Loader size="medium" /></LoaderDiv>}
          >
            <Table
              columns={columns}
              dataSource={blockers}
              height="calc(100vh - 99px - 60px)"
              loading={loading}
              onChange={onChange}
              isInfinite
              className="bb-0"
            />
          </InfiniteScroll>
        </InfiniteScrollTableWrapper>
      </Content>
    </ContentWrapper>
  );
}
